import { LoadingOutlined } from "@ant-design/icons";
import { Space, Spin } from "antd";
const Spinner = ({ size }) => (
  <Space>
    <Spin indicator={<LoadingOutlined spin />} size={size} />
  </Space>
);
export default Spinner;
